import React from 'react';
import TableReport from "../../common/table/table";
import ClientJobsTable from "./clientJobsTable";
import MessageEmptyData from "../../common/messageEmptyData";

/**
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const ClientJobsBody = (prop) => {
    const {filters, tableData, setSelectedFilesRow, setFormModalFiles} = prop;

    if (!filters.isSubmitted) {
        return null;
    }

    if (tableData.length === 0) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableReport
                columns={ClientJobsTable(setSelectedFilesRow, setFormModalFiles)}
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'client_jobs'}
                withGlobalSearch={true}
                scrollable={true}
            />
        </div>
    );
}

export default ClientJobsBody;
